import CONST_REQUEST from '../../constants/request';
import * as api from '../../webpublicapi/operation';
import apiTools from '../../utils/store'

const types = {
    ...apiTools.getTypes([
        'accountList',
    ]),
}

const getDefaultState = () => {
    return {
        ...apiTools.getStates([
            'accountList',
        ]),
    }
}

const getters = {
        ...apiTools.getGetters([
            'accountList',
        ])
    }

const buildAction = (apiName) => {
    return ({ commit }, params) => {
        return api[apiName](params).then((res) => {
            if (res.code == CONST_REQUEST.CODE_SUCCESS) {
                return res
            } else {
                throw new Error(res.msg)
            }
        })
    }
}

const actions = {
        ...apiTools.getActions([
            'getAccountList',
        ], { types, api, CONST_REQUEST }),
        addAccount: buildAction('addAccount'),
        editAccount: buildAction('editAccount'),
        deleteAccount: buildAction('deleteAccount'),
    }

const mutations = {
    ...apiTools.getMutations([
        'accountList',
    ], { types, CONST_REQUEST })
}


export default {
    namespaced: true,
    state: getDefaultState(),
    getters,
    actions,
    mutations
}